import 'react-toastify/dist/ReactToastify.css'
import Router from './router/Router'
import { AdminContextProvider } from './contexts/AdminContext'
import React from 'react'
import { useAuth } from './contexts/AuthContext'

const Backend: React.FC = () => {
    const { role } = useAuth()

    return (
        <>
            {role === 'admin' ? (
                <AdminContextProvider>
                    <Router />
                </AdminContextProvider>
            ) : (
                <Router />
            )}
        </>
    )
}

export default Backend
